export default `제1조 (목적)

이 약관은 공식 대회 주관사(이하 “대회사”) 또는 주식회사 프리플랍(이하 “회사”)이 주최하거나 연계하여 운영하는 공식 홀덤 대회(이하 “대회”)에 참가하고자 하는 회원이 제출하는 신청 절차, 참가 조건, 권리 및 의무, 기타 필요한 사항을 규정함을 목적으로 합니다.

제2조 (정의)

이 약관에서 사용하는 용어의 정의는 다음과 같습니다.

1. “대회”란 대회사 또는 회사가 주최하거나 연계하여 운영하는 텍사스 홀덤 기반의 공식 게임 이벤트를 의미합니다.
2. “참가자”란 회사의 회원 중 대회 참가를 신청하고, 회사 또는 대회사로부터 참가 승인을 받아 실질적으로 대회에 참가하는 자를 말합니다.
3. “참가 신청”이란 회원이 대회에 참가하기 위해 공식 채널을 통해 접수하는 절차를 의미합니다.
4. “참가권”이란 참가자가 대회에 참가할 수 있는 자격으로, 조건 충족, 초청, 이벤트 등을 통해 획득할 수 있는 비양도성 권리를 말합니다.
5. “공식 채널”이란 회사 또는 대회사가 운영하는 앱 내 신청 시스템, 웹사이트, 고객센터, 파트너 매장 등을 포함합니다.
6. “운영진”이란 대회 운영을 위해 회사 또는 대회사가 지정한 주최자, 심판, 스태프 등을 의미합니다.

제3조 (신청 및 승인)

1. 참가 신청은 회사 또는 대회사가 지정한 공식 채널을 통해서만 가능하며, 참가자는 해당 신청 절차를 정확하게 완료해야 합니다.
2. 참가자는 신청 시 회사 또는 대회사가 요구하는 정보를 정확하고 성실하게 기재해야 하며, 허위 정보나 타인의 정보를 도용한 경우 참가 승인이 제한되거나 취소될 수 있습니다.
3. 회사 또는 대회사는 신청 내용을 검토한 후, 참가 승인을 거부하거나 이미 승인된 참가를 취소할 수 있습니다.
    - 과거 대회에서 부정행위 또는 질서 문란 등의 이력이 있는 경우
    - 허위 정보를 기재하거나 타인의 정보를 도용한 경우
    - 신청 자격 기준(연령, 회원 등급, 참가권 보유 등)을 충족하지 못한 경우 기타 대회 운영에 지장을 초래할 우려가 있다고 판단되는 경우
4. 참가 승인을 받은 자는 안내된 일시 및 장소에 따라 대회에 참가하여야 하며, 무단 불참 시 향후 참가 제한 등의 제재가 있을 수 있습니다.

제4조 (참가자의 의무)

1. 참가자는 대회 신청 및 참가와 관련하여 회사 또는 대회사가 정한 본 약관, 운영정책, 대회 규칙, 공지사항 및 운영진의 안내에 따라야 하며, 이를 위반할 경우 참가 제한, 실격, 향후 참가 불가 등의 불이익을 받을 수 있습니다.
2. 참가자는 다음 각 호의 행위를 하여서는 안 됩니다.
    - 허위 정보 제공, 타인의 명의 사용 등 부정한 방법으로 대회에 신청하거나 참가하는 행위
    - 대회 운영을 방해하거나 다른 참가자에게 피해를 주는 언행 또는 물리적 행위
    - 사전에 허가받지 않은 촬영, 중계, 녹음 등의 행위
    - 운영진의 판단에 따라 부정행위로 간주될 수 있는 일체의 행위 (예: 신호 주고받기, 칩 던지기 규정 위반 등)
5. 사행성 조장, 도박성 내기 유도 등 관계 법령에 위반되는 행위
3. 참가자는 본인의 계정과 참가권을 제3자에게 양도하거나 공유할 수 없으며, 위반 시 즉시 실격 처리됩니다.
4. 참가자는 대회 시작 전까지 정해진 시간 내에 등록 및 본인 확인 절차를 완료해야 하며, 지연 또는 미도착 시 참가 자격이 제한될 수 있습니다.
5. 참가자는 대회 결과에 대해 정당한 절차를 거쳐 이의제기를 할 수 있으나, 결과 확정 이후에는 어떠한 이의도 제기할 수 없습니다.

제5조 (대회 변경 및 취소)

1. 회사 또는 대회사는 천재지변, 재난, 정부 지침, 참가자 미달, 제휴처의 사정 등 불가피한 사유가 발생한 경우, 대회의 전부 또는 일부를 변경, 연기, 중단, 취소할 수 있습니다.
2. 제1항에 따른 변경 또는 취소가 발생한 경우, 회사 또는 대회사는 가능한 한 신속하게 참가자에게 앱 내 공지사항, 푸시 알림, 문자, 전화 등의 방법으로 이를 통지합니다.
3. 회사 또는 대회사는 참가자 본인의 귀책사유(예: 지각, 무단 불참, 본인 확인 실패 등)로 인해 참가하지 못한 경우, 참가권의 환불, 이월, 대체 참가 등을 제공하지 않습니다.
4. 대회가 운영 측 사정으로 인해 완전히 취소되는 경우, 회사는 해당 참가자에게 참가권 반환 또는 이에 준하는 보상을 별도의 기준에 따라 제공합니다.
5. 회사 또는 대회사는 대회의 일부 구성(예: 포맷, 장소, 상금 구성, 진행 방식 등)을 사전 고지 후 변경할 수 있으며, 참가자는 변경 사항에 이의를 제기할 수 없습니다.
6. 참가자는 정당한 사유 없이 반복적으로 대회에 무단 불참할 경우, 회사는 해당 참가자의 향후 대회 참가를 제한할 수 있습니다.

제6조 (초상권 및 촬영 동의)

1. 참가자는 대회 현장에서 운영진 또는 회사, 제휴 매체 등에 의해 사진, 영상, 음성 등이 촬영될 수 있으며, 해당 자료는 다음 목적에 따라 사용될 수 있음을 이해하고 이에 동의합니다.
    - 대회 결과 공지, 이벤트 기록 보관
    - 회사 또는 대회사의 홍보 및 마케팅 활용(예: SNS, 유튜브, 보도자료 등)
    - 서비스 내 콘텐츠(예: 대회 하이라이트, 교육용 자료 등) 제작
2. 제1항에 따라 촬영된 사진, 영상 등은 회사가 정한 방법 및 범위 내에서 편집되어 활용될 수 있으며, 참가자는 이에 대해 초상권, 저작권 또는 기타 일체의 권리를 주장하거나 보상을 요구할 수 없습니다.
3. 참가자가 촬영 또는 공개에 대해 민감한 사유가 있는 경우, 사전에 회사에 서면 요청을 통해 일부 사용 제한을 요청할 수 있으며, 회사는 이에 대해 합리적 범위 내에서 검토 후 조치할 수 있습니다.
4. 참가자는 대회 중 별도의 허가 없이 운영 공간 내에서 상업적 목적의 촬영, 중계, 녹화, 실시간 방송 등을 할 수 없습니다.

제7조 (책임 제한)

1. 회사 또는 대회사는 천재지변, 정부의 명령, 감염병 확산, 통신 장애, 기타 불가항력적인 사유로 인해 대회를 정상적으로 진행할 수 없는 경우, 그로 인한 책임을 지지 않습니다.
2. 참가자의 개인 사정(건강 이상, 일정 착오, 교통 문제 등)으로 인해 대회에 정상적으로 참가하지 못하거나 불이익이 발생한 경우, 회사 또는 대회사는 이에 대해 책임을 지지 않습니다.
3. 참가자의 부주의, 규칙 위반, 사전 고지된 운영방침 미숙지로 인해 발생한 불이익은 참가자 본인의 책임이며, 이에 대해 회사 또는 대회사는 일체 책임을 지지 않습니다.
4. 대회 중 발생할 수 있는 응급 상황(예: 탈진, 사고, 질병 등)에 대해 회사 또는 대회사는 현장 응급처치를 제공하거나 의료기관 이송을 지원할 수 있으나, 그 이후 치료에 대한 책임이나 비용은 참가자 본인에게 있습니다.
5. 회사 또는 대회사는 참가자를 대상으로 별도의 상해보험이나 손해보험에 가입하지 않으며, 참가자는 필요한 경우 스스로 보험에 가입하거나 보호 조치를 취해야 합니다.
6. 참가자는 대회 참가 중 발생할 수 있는 일체의 사고, 부상, 장비 파손 등에 대해 스스로 주의 의무를 다해야 하며, 회사 또는 대회사는 법령상 허용된 범위 내에서 그 책임을 제한할 수 있습니다.
7. 대회에서 제공되는 리워드(예: 경품, 상금 등)는 사전 고지된 조건 및 절차에 따라 제공되며, 회사 또는 대회사는 해당 품목의 품질, 배송, 사용 등에 대한 책임을 별도로 부담하지 않습니다.

제8조 (분쟁 해결 및 관할)

1. 본 약관 및 대회 참가와 관련하여 회사 또는 대회사와 참가자 간에 발생한 분쟁에 대해서는 대한민국 법률을 준거법으로 합니다.
2. 대회 운영과 관련된 참가자의 이의제기, 민원, 분쟁은 회사 또는 대회사가 정한 절차에 따라 접수 및 조정되며, 참가자는 이에 성실히 협조하여야 합니다.
3. 회사 또는 대회사와 참가자 간의 분쟁이 원만히 해결되지 않아 소송이 제기되는 경우, 회사의 본점 소재지를 관할하는 지방법원을 제1심 전속 관할 법원으로 합니다.
4. 참가자가 해외에 거주하거나 외국인인 경우에도, 본 조항은 동일하게 적용됩니다.
`